import {FormikSelect} from '@flexinet/ui-components';
import {useBillableUnits} from '../hooks/useBillableUnits.ts';
import {BillableUnit} from '../types';
import {FieldProps} from 'formik';
import {SelectProps} from '@mantine/core';

// FNP-802: the selector a RatePlan uses to pick the unit it prices. Labels carry the
// meter alongside the name ("1000 Domains Managed — domains.created") so the person
// choosing can see WHAT IS MEASURED, not just the display name — picking the wrong unit
// silently prices the wrong meter.
export const BillableUnitsDropdown = (props: FieldProps & SelectProps) => {

    const {items} = useBillableUnits();

    const selectOptions = items.map((item: BillableUnit) => {
        const meterCode = item.meter?.meterCode ?? item.meterId;
        return {
            value: item.id,
            label: meterCode ? `${item.name} — ${meterCode}` : item.name,
        };
    });

    return <FormikSelect {...props} data={selectOptions}/>;
};
